import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import { useTranslator } from '@/hooks/useTranslator';
import { CryptoAccount } from '@/types/contacts';

interface Props {
  readonly account: CryptoAccount;
}

export const CryptoAccountTransactionDetailsItem: React.FC<Props> = (
  props: Props,
): React.ReactElement => {
  const { account } = props;

  const tr = useTranslator();

  return (
    <Box>
      <Typography variant="body2" color="text.primary">
        {tr(account.name)} ({account.currency})
      </Typography>
    </Box>
  );
};
